module.exports = __webpack_public_path__ + "media/components/alert-table/static/icon-box-42e558a7b3ae9ac1235763d3fcab0efd.svg";